import { dataHooks } from '../../../../libs/dataHooks';

export const layoutsFilterDataHooks = dataHooks<{
  filterItem: { id: string };
}>('layouts-filters');
